export default [{
  path: '/authorize',
  component: resolve => require(['@/components/base/view/authorize/authorize.vue'], resolve) //授权认证
},{
  path: '/error',
  component: resolve => require(['@/components/base/view/cmps/500/ServerError.vue'], resolve) //500
}, {
  path: '/home',
  component: resolve => require(['@/components/base/view/main/main.vue'], resolve),
  children: [{
    path: '/enum',
    component: resolve => require(['@/components/base/view/enum/cfg/cfg.vue'], resolve) //枚举管理
  }, {
    path: '/version',
    component: resolve => require(['@/components/base/view/version/pc/version.vue'], resolve) //版本管理---PC端版本
  }, {
    path: '/version/app',
    component: resolve => require(['@/components/base/view/version/app/app.vue'], resolve) //app版本管理
  }, {
    path: '/org/:key',
    component: resolve => require(['@/components/base/view/org/org/org.vue'], resolve) // 组织机构
  }, {
    path: '/sh/tag',
    component: resolve => require(['@/components/base/view/org/tag/tag.vue'], resolve) // 用户标签
  }, {
    path: '/role',
    component: resolve => require(['@/components/base/view/org/role/role.vue'], resolve) // 角色管理
  }, {
    path: '/user/edit/:id/:org',
    component: resolve => require(['@/components/base/view/org/org/cmps/users/edit/edit.vue'], resolve) // 人员编辑
  }, {
    path: '/user/center/:id',
    component: resolve => require(['@/components/base/view/org/org/cmps/users/my/my.vue'], resolve) // 个人中心
  }, {
    path: '/msg',
    component: resolve => require(['@/components/base/view/msg/list/list.vue'], resolve) //消息列表
  }, {
    path: '/comment/audit',
    component: resolve => require(['@/components/base/view/interact/comment/audit.vue'], resolve) //评论审核
  }, {
    path: '/vote',
    component: resolve => require(['@/components/base/view/interact/vote/list/list.vue'], resolve) //投票管理
  }, {
    path: '/vote/edit/:id',
    component: resolve => require(['@/components/base/view/interact/vote/edit/edit.vue'], resolve) //投票列表
  }, {
    path: '/vote/info/:id',
    component: resolve => require(['@/components/base/view/interact/vote/info/info.vue'], resolve) //投票详情
  }, {
    path: '/suggest/edit',
    component: resolve => require(['@/components/base/view/interact/suggest/edit/edit.vue'], resolve) //填写建议反馈
  }]
}, {
  path: '/vote/join/:id',
  component: resolve => require(['@/components/base/view/interact/vote/join/join.vue'], resolve) //参与投票界面
}, {
  path: '/yd/auth',
  component: resolve => require(['@/components/base/view/msg/youdu/auth.vue'], resolve) //有度用户验证界面
}]



// WEBPACK FOOTER //
// ./src/components/base/router/base.js